import { createContext } from "react";

/**
 * @type {import("react").Context<import("../../../../../types/documentActions").UseDocumentV2I>}
 */
const DocumentContext = createContext(undefined);

export default DocumentContext;